import React, { useEffect, useState } from "react";
import { ReactComponent as Clock } from "../../../assets/icons/clock.svg";

import { twMerge } from "tailwind-merge";
import CircularTimer from "./CircularTimer";
interface Props {
  className?: string;
  textClassName?: string;
  time?: string | number;
  onEnd?: () => void;
  onAlert?: () => void;  
  onTimeChange?: (time: number) => void;
  isAbsolute?: boolean;
}
// make this timer as count down. at 7 seconds left it should send an alert and onEnd event at the end.
const ClockTimer = ({
  className = "",
  textClassName = "",
  time = "",
  onEnd,
  onAlert,
  onTimeChange,
  isAbsolute = true,
}: Props) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const intervalRef = React.useRef<any>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft === 0) {
          clearInterval(intervalRef.current)
          onEnd && onEnd();
          return prevTimeLeft;
        }
        if (prevTimeLeft - 1 === 12) {
          onAlert && onAlert();
        }
        onTimeChange && onTimeChange(prevTimeLeft - 1);
        return prevTimeLeft - 1
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  useEffect(() => {
    if (time) {
      setTimeLeft(Number(time) * 60)
    }
  }, [time]);

  return (
    <div className={isAbsolute ? "absolute top-[18px] right-10 z-10" : "flex justify-center items-center w-full mt-8"}>
      <CircularTimer
        timeLeft={timeLeft}
        time={Number(time) * 60}
        size={isAbsolute ? 138 : 120}
        strokeWidth={8}
        centerText={`${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`}
        isTimeOver={timeLeft < 120}
        isAbsolute={isAbsolute}
        textColor={isAbsolute ? undefined : "black"}
        textSizeClass={isAbsolute ? "text-[41px]" : "text-3xl"}
      />
    </div>
  )
};

export default React.memo(ClockTimer);
